import { customerFunctions } from 'packs/customers/functions'
import { Tooltip } from 'bootstrap'

export default () => {
  customerFunctions()

  $('#myyja-notes-datatable').DataTable({
    language: {
      url: '/datatable_i18n'
    },
    processing: true,
    serverSide: true,
    ajax: {
      url: $('#myyja-notes-datatable').data('source')
    },
    order: [[9, 'asc']],
    columns: [
      { data: 'company_name' },
      { data: 'location_name' },
      { data: 'business_id' },
      { data: 'industry' },
      { data: 'address' },
      { data: 'contact_person' },
      { data: 'phone' },
      { data: 'email' },
      {
        data: 'notes',
        className: 'notes-col',
        createdCell: function(td, cellData, rowData) {
          if (rowData.notes_full) {
            td.setAttribute('data-bs-toggle', 'tooltip')
            td.setAttribute('data-bs-placement', 'left')
            td.setAttribute('data-bs-custom-class', 'notes-tooltip')
            td.setAttribute('title', rowData.notes_full)
          }
        }
      },
      { data: 'follow_up_date' }
    ],
    drawCallback: function() {
      document.querySelectorAll('#myyja-notes-datatable [data-bs-toggle="tooltip"]').forEach(function(el) {
        var existing = Tooltip.getInstance(el)
        if (existing) existing.dispose()
        new Tooltip(el)
      })
    }
  })
}
